var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLockEvent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLockEvent") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.54819336,12.5963867 C3.21327213,12.5963867 0.5,9.88311458 0.5,6.54819336 C0.5,3.21327213 3.21327213,0.5 6.54819336,0.5 C9.88311458,0.5 12.5963867,3.21327213 12.5963867,6.54819336 C12.5963867,9.88311458 9.88311458,12.5963867 6.54819336,12.5963867 Z M6.54819336,1.3787725 C3.697627,1.3787725 1.3787725,3.697627 1.3787725,6.54819336 C1.3787725,9.39875972 3.697627,11.7176142 6.54819336,11.7176142 C9.39875972,11.7176142 11.7176142,9.39875972 11.7176142,6.54819336 C11.7176142,3.697627 9.39875972,1.3787725 6.54819336,1.3787725 Z M6.46296493,7.63336872 C6.42930542,7.63336872 6.39511998,7.6260057 6.36251233,7.61338338 C6.26416344,7.57288678 6.2,7.47664162 6.2,7.37040379 L6.2,3.16296493 C6.2,3.01833422 6.31780829,2.9 6.46296493,2.9 C6.60812157,2.9 6.72592986,3.01833422 6.72592986,3.16296493 L6.72592986,6.73560645 L8.38050519,5.08103112 C8.48253558,4.97900073 8.64978128,4.97900073 8.7523376,5.08103112 C8.85436799,5.18358744 8.85436799,5.35083314 8.7523376,5.45286353 L6.64861817,7.55658296 C6.59865483,7.60654629 6.53133581,7.63336872 6.46296493,7.63336872 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "See-comments",
    transform: "translate(-89.000000, -290.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(89.000000, 286.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/DateFinder-Copy",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icLockEvent",
    fill: "#A5A5A5",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLockEvent);
export default __webpack_public_path__ + "static/media/icLockEvent.e1594d504671504f804ea88c3153f312.svg";
export { ForwardRef as ReactComponent };